<template>
    <div class="container-fluid">
        <div class="row">
            <DetailAssessment/>
        </div>
    </div>
</template>
<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { useRoute , useRouter } from 'vue-router';
const DetailAssessment = defineAsyncComponent(() => import("@/components/theme/ma/DetailAssessment"))
</script>